import client from './client'
import type { CrowdSubmission } from '../types'

export interface SubmitItemData {
  assignment_id: string
  task_item_id: string
  submission_type: 'found' | 'not_found'
  price_uzs?: number
  price_usd?: number
  shop_name?: string
  stall_section?: string
  shop_latitude?: number
  shop_longitude?: number
  shop_phone?: string
  shop_address?: string
  shop_category?: string
  shop_description?: string
  selected_merchant_id?: string
  product_name?: string
  product_brand?: string
  product_description?: string
  comment?: string
}

export async function getSubmissionsForAssignment(assignmentId: string): Promise<CrowdSubmission[]> {
  const res = await client.get(`/v1/crowd/submissions/assignments/${assignmentId}`)
  return res.data
}

export async function submitItem(data: SubmitItemData): Promise<CrowdSubmission> {
  const res = await client.post('/v1/crowd/submissions/', data)
  return res.data
}

export interface FreeSubmitData {
  shop_name: string
  product_name: string
  lang?: string
  price_uzs?: number
  price_usd?: number
  category_id?: string
  keywords?: string[]
  brand?: string
  stall_section?: string
  shop_latitude?: number
  shop_longitude?: number
  shop_phone?: string
  shop_address?: string
  shop_category?: string
  shop_description?: string
  selected_merchant_id?: string
  description?: string
  comment?: string
}

export async function submitFree(data: FreeSubmitData): Promise<CrowdSubmission> {
  const res = await client.post('/v1/crowd/submissions/free', data)
  return res.data
}

export async function getMySubmissions(skip = 0, limit = 30) {
  const res = await client.get('/v1/crowd/submissions/my', { params: { skip, limit } })
  return res.data as { items: CrowdSubmission[]; total: number }
}

export async function addPhoto(submissionId: string, photo: File): Promise<void> {
  const form = new FormData()
  form.append('photo', photo)
  await client.post(`/v1/crowd/submissions/${submissionId}/photos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
